import { useId } from 'react'

import { QuillEditor } from '@reveni-io/reveni-ui'

import QuillToolbar from '../QuillToolbar/QuillToolbar'
import * as Styles from './styles'

const defaultConfig = { bold: true, italic: true }

const RichTextEditor = ({
  value,
  onChange,
  placeholder,
  config = defaultConfig,
  minHeight = '60px',
  maxHeight,
  editorRef,
  toolbarRef,
  variables,
  disabled,
  languageKey,
  onAddLink,
  onAddImage,
  onAddVariable,
  availableVariables,
  availableSections,
  onImageUpload,
}) => {
  const id = useId()
  const toolbarId = `rich-text-toolbar-${id.replace(/:/g, '')}`

  return (
    <Styles.Container maxHeight={maxHeight}>
      <QuillToolbar
        toolbarId={toolbarId}
        config={config}
        ref={toolbarRef}
        onAddLink={onAddLink}
        onAddImage={onAddImage}
        onAddVariable={onAddVariable}
        availableVariables={availableVariables}
        availableSections={availableSections}
      />
      <QuillEditor
        value={value}
        onChangeText={onChange}
        placeholder={placeholder}
        quillTheme="snow"
        customToolbarId={`#${toolbarId}`}
        minHeight={minHeight}
        textType="html"
        editorRef={editorRef}
        variables={variables}
        disabled={disabled}
        onImageUpload={onImageUpload}
        key={languageKey}
      />
    </Styles.Container>
  )
}

export default RichTextEditor
